export class CertificateLabel {
    id!: number;
    xcoordinate!: number;
    ycoordinate!: number;
    height!: number;
    width!: number;
    pageIndex!: number;
}
